/* eslint-disable camelcase */
import Axios from 'axios'
import globalConfig from '../config'

export const ticketService = {
  tT: async (id_boleto, compadre) => {
    // console.log('ID_BOLETO', id_boleto)
    // console.log('COMPADRE', compadre)
    const { data } = await Axios.put(`${globalConfig.url}/api/boletos/transfer/${id_boleto}`, compadre)
    return data
  }
}
